import { createActions } from 'redux-actions';
import {
  BasicActionFunction,
  DefaultRoutine,
  DefaultRoutineActions,
} from '../../utils';
import { IQuestionnaireAnswersState } from '../../../redux/selectors';

interface AuthActions {
  auth: {
    authenticated: BasicActionFunction;
    unauthenticated: BasicActionFunction;
    tokensReady: BasicActionFunction;
    checkEmail: DefaultRoutineActions;
    changePassword: DefaultRoutineActions<{
      oldPassword: string;
      newPassword: string;
    }>;
    forgotPassword: DefaultRoutineActions;
    incrementOnboarding: BasicActionFunction;
    load: DefaultRoutineActions;
    login: DefaultRoutineActions;
    logout: DefaultRoutineActions;
    processOauthCode: DefaultRoutineActions<{
      code: string;
      redirectUri: string;
    }>;
    refresh: DefaultRoutineActions;
    resetPassword: DefaultRoutineActions;
    signup: DefaultRoutineActions;
    update: DefaultRoutineActions;
    federated: DefaultRoutineActions;
    updateSettings: DefaultRoutineActions;
    acceptWaiver: DefaultRoutineActions;
    confirmForgotPassword: DefaultRoutineActions;
    clearSignupErrors: DefaultRoutineActions;
    changeDefaultStation: DefaultRoutineActions;
    incrementExperience: DefaultRoutineActions;
    watchForEntitlements: DefaultRoutineActions;
    updateUserAttributes: DefaultRoutineActions;
    submitQuestionnaireAnswers: DefaultRoutineActions<IQuestionnaireAnswersState>;
  };
}

const Actions = <AuthActions>(<unknown>createActions({
  AUTH: {
    AUTHENTICATED: undefined,
    UNAUTHENTICATED: undefined,
    TOKENS_READY: undefined,
    CHECK_EMAIL: DefaultRoutine,
    CHANGE_PASSWORD: DefaultRoutine,
    FORGOT_PASSWORD: DefaultRoutine,
    INCREMENT_ONBOARDING: undefined,
    LOAD: DefaultRoutine,
    LOGIN: DefaultRoutine,
    LOGOUT: DefaultRoutine,
    REFRESH: DefaultRoutine,
    RESET_PASSWORD: DefaultRoutine,
    SIGNUP: DefaultRoutine,
    UPDATE: DefaultRoutine,
    FEDERATED: DefaultRoutine,
    UPDATE_SETTINGS: DefaultRoutine,
    ACCEPT_WAIVER: DefaultRoutine,
    CONFIRM_FORGOT_PASSWORD: DefaultRoutine,
    CLEAR_SIGNUP_ERRORS: DefaultRoutine,
    CHANGE_DEFAULT_STATION: DefaultRoutine,
    INCREMENT_EXPERIENCE: DefaultRoutine,
    PROCESS_OAUTH_CODE: DefaultRoutine,
    WATCH_FOR_ENTITLEMENTS: DefaultRoutine,
    UPDATE_USER_ATTRIBUTES: DefaultRoutine,
    SUBMIT_QUESTIONNAIRE_ANSWERS: DefaultRoutine,
  },
}));

export const authSuccessActions = [
  Actions.auth.load.success,
  Actions.auth.login.success,
  Actions.auth.federated.success,
  Actions.auth.signup.success,
];

export default Actions;
